import { SourceOfWealthService } from '@/modules/global-settings/miscellaneous/services/source-of-wealth.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new instance of the SourceOfWealthService class
const sourceService = new SourceOfWealthService();
// Source of Wealth module state
export const state = {
  sourceOfWealthSettings: []
};
// Source of Wealth module mutations
export const mutations = {
  ...make.mutations(state)
};
// Source of Wealth module actions
export const actions = {
  /**
   * Fetches all Source of Wealth settings
   * @param {Object} context - Vuex action context
   * @returns {Array} Array of Source of Wealth settings
   * @private This sets the Source of Wealth settings in the state
   */
  getSourceOfWealth: async ({ commit }) => {
    try {
      const { data } = await sourceService.getSourceOfWealth();
      commit('SET_SOURCE_OF_WEALTH_SETTINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting source of wealth settings');
      throw error;
    }
  },

  /**
   * Creates a Source of Wealth setting
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Source of Wealth payload
   * @returns {Object} Source of Wealth settings
   * @private This will re-fetch the Source of Wealth settings & set them in state
   *
   */
  createSourceOfWealth: async ({ dispatch }, payload) => {
    try {
      const { data } = await sourceService.createSourceOfWealth(payload);
      dispatch('getSourceOfWealth');
      return data;
    } catch (error) {
      Logger.error('creating source of wealth settings');
      throw error;
    }
  },

  /**
   * Updates a Source of Wealth setting
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Source of Wealth payload
   * @param {String} payload.id - Source of Wealth ID
   * @param {Object} payload.payload - Source of Wealth updates
   * @returns {void}
   * @private This will re-fetch the Source of Wealth settings & set them in state
   */
  updateSourceOfWealth: async ({ dispatch }, { id, payload }) => {
    try {
      await sourceService.updateSourceOfWealth(id, payload);
      dispatch('getSourceOfWealth');
    } catch (error) {
      Logger.error('updating source of wealth settings');
      throw error;
    }
  },

  /**
   * Deletes a Source of Wealth
   * @param {Object} context - Vuex action context
   * @param {String} id - Source of Wealth ID
   * @returns {void}
   * @private This will re-fetch the Source of Wealth settings & set them in state
   */
  deleteSourceOfWealth: async ({ dispatch }, id) => {
    try {
      await sourceService.deleteSourceOfWealth(id);
      dispatch('getSourceOfWealth');
    } catch (error) {
      Logger.error('updating source of wealth settings');
      throw error;
    }
  }
};
// Source of Wealth module getters
export const getters = {
  ...make.getters(state),
  activeSourceOfWealthSettings(state) {
    return state.sourceOfWealthSettings.filter((s) => s.status == true);
  }
};
